import IgniteModal from "@ignitesales/react-modal";
import { ConnectedContactFlow } from "@ignitesales/social-contact-appointment-form";
import classNames from "classnames";
import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import GuideContext from '../GuideContext';
import CartProduct from './CartProduct';

export default function ContactCart({ onSubmit, onClose, className, show, productCart, onCartDelete, renderOtherAccounts, showCart, setShowCart }) {
  const { isBusinessGuide } = useContext(GuideContext);
  const guideType = isBusinessGuide ? 'business' : 'consumer';

  const renderCart = () => (
    <>
      <div className="cartTitle"><FormattedMessage id="cart.title" /></div>
      <div className="cartSubTitle"><FormattedMessage id="cart.subtitle" /></div>
      <div className="cartProductsGroup">
        <div className="cartProductsTitle"><FormattedMessage id="cart.products" /></div>
        <div className="cartProductList">
          {productCart.size > 0 ?
            <div>
              {[...productCart].map((product) => {
                return <CartProduct productId={product} key={product} onCartDelete={onCartDelete} />
              })}
            </div>
            :
            <div className="cartProductEmpty"><FormattedMessage id="cart.empty.products" /></div>
          }
        </div>
      </div>
      {!isBusinessGuide && (
        <div className="cartGoalsGroup">
          <div className="cartGoalsTitle"><FormattedMessage id="cart.goals" /></div>
          <div className="cartGoalsList">
            {renderOtherAccounts(true)}
          </div>
        </div>
      )}
    </>
  );

  const renderForm = () => (
    <ConnectedContactFlow
      onComplete={onSubmit}
      hasBeenClicked={show}
      guideType={guideType}
    />
  );

  return (
    <IgniteModal
      className={classNames("contactUs contactCart", className)}
      show={show}
      onClose={onClose}
    >
      <section className="container mobile">
        <div className="row">
          {showCart ?
            <>
              <div className="col textInput cart">
                {renderCart()}
                <div className="contactCartNavigationBar" ><button className={`btn btn-primary next contactCartNavigationButton`} onClick={() => setShowCart(false)}><FormattedMessage id="cart.navigation.next" /></button></div>
              </div>
            </>
            :
            <div className="col textInput form">
              {renderForm()}
              <div className="contactCartNavigationBar" ><button className={`btn btn-secondary back contactCartNavigationButton`} onClick={() => setShowCart(true)}><FormattedMessage id="cart.navigation.back" /></button></div>
            </div>
          }
        </div>
      </section>
      <section className="container desktop">
        <div className="row">
          <div className="col textInput cart">
            {renderCart()}
          </div>
          <div className="col textInput form">
            {renderForm()}
          </div>
        </div>
      </section>
    </IgniteModal>
  );
}
